import React, { useState, useEffect } from 'react';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import ActionDialog from './ActionDialog';

const AdMarkDialog = ({ open, onClose, onConfirm, defaultAdMarked = true }) => {
  const [isAdMarked, setIsAdMarked] = useState(defaultAdMarked);

  useEffect(() => {
    if (open) {
      setIsAdMarked(defaultAdMarked);
    }
  }, [open, defaultAdMarked]);

  const handleConfirm = () => {
    onConfirm(isAdMarked);
  };

  return (
    <ActionDialog open={open} onClose={onClose} onConfirm={handleConfirm} title="광고 마크 관리">
      <RadioGroup
        value={String(isAdMarked)}
        onChange={(e) => setIsAdMarked(e.target.value === 'true')}
      >
        <FormControlLabel
          value="true"
          control={<Radio size="small" />}
          label="광고 마크 추가"
          sx={{ '& .MuiFormControlLabel-label': { fontSize: 14 } }}
        />
        <FormControlLabel
          value="false"
          control={<Radio size="small" />}
          label="광고 마크 해제"
          sx={{ '& .MuiFormControlLabel-label': { fontSize: 14 } }}
        />
      </RadioGroup>
    </ActionDialog>
  );
};

export default AdMarkDialog;
